import { Modal } from "antd";

export const SubscriptionModal = ({ onClose }) => {
  Modal.info({
    title: "Subscription Required",
      content: (
      <p style={{ whiteSpace: "normal", wordBreak: "break-word", textAlign: "center"  }}>
        Your organization admin has not completed the subscription payment.
        Services will be unavailable until they complete the obligations.
      </p>
    ),
    style: { maxWidth: "520px" },
    okText: "Go to Payment Information",
    // closable: true,          // shows X (top-right)
    centered: true,          // center of screen
    width: 400,              // bigger modal
    icon: null,              // removes yellow info icon
    maskClosable: false,     // optional: disable click outside to close

    onOk() {
      onClose?.();
      window.location.href = "/payment";
    },

    // onCancel() {
    //   onClose?.();
    // },
  });
};
